import { Button, Skeleton } from "@netfront/ui-library";

import { CONSTANTS } from "@/constants";
import { LessonCard, ProgressCircle } from "@/components";

import { LessonCardsProps } from "./LessonCards.interfaces";
import { LessonAssets } from "./LessonAssets";

export const LessonCards = ({ completedFeedbackCount = 0, lessons, isLoading: isLessonsLoading, roleTag }: LessonCardsProps) => {
  const startedLessonsCount = lessons.filter(({ id, percentageCompleted }) => id !== CONSTANTS.USERFLOW.CARTOONS.STEPS.BACKSTORY.ID && percentageCompleted > 0).length;

  return isLessonsLoading ? (
    <div className="grid gap-3">
      <Skeleton height='10rem' width='100%' />
      <Skeleton height='10rem' width='100%' />
      <Skeleton height='10rem' width='100%' />
    </div>
  ) : lessons && lessons.length > 0 ? (
    <ol className="m-0 list-style-none grid gap-3">
      {lessons.map((step) => {
        const { contentGroup, id, percentageCompleted, isComplete, url, sort } = step;

        const percentageCompletedRounded = Math.round(percentageCompleted * 100);

        const logbookAsset = roleTag === 'Teacher' && sort && isComplete
          ? `/teacher/logbook/teacher-logbook-week-${sort}/questions-lesson-${sort}`
          : undefined;

        const canStudentAccess = isComplete || id === CONSTANTS.USERFLOW.CARTOONS.STEPS.BACKSTORY.ID || percentageCompleted > 0 || completedFeedbackCount > startedLessonsCount

        return(
          <li key={id} className="ml-0">
            <LessonCard
              title={contentGroup.title}
              description={contentGroup.description}
              {...contentGroup.iconAsset?.presignedUrl && {
                image: {
                  alt: contentGroup.iconAsset?.alt || `Icon for ${contentGroup.title}`,
                  src: contentGroup.iconAsset?.presignedUrl,
                }
              }}
              percentageCompleted={percentageCompletedRounded}
              button={{
                additionalClassNames: 'ml-auto w-full md:w-52 md:ml-auto',
                variant: percentageCompletedRounded === 0 || percentageCompletedRounded === 100 ? 'primary' : 'tertiary',
                text: percentageCompletedRounded === 0 ? 'Begin' : isComplete ? 'Review' : 'Continue',
                ...(roleTag === 'Student' ? {
                  onClick: () => {
                    if (!canStudentAccess) {
                      localStorage.setItem('student-lesson-url', `/${CONSTANTS.USERFLOW.CARTOONS.URL}/${url}`);
                    } else {
                      localStorage.removeItem('student-lesson-url');
                    }
                  },
                  linkButton: {
                    id: `module-${contentGroup.id}`,
                    url: canStudentAccess ? `/${CONSTANTS.USERFLOW.CARTOONS.URL}/${url}` : '/student/personal-feedback'
                  }
                } : {
                  linkButton: {
                    id: `module-${contentGroup.id}`,
                    url: `/${CONSTANTS.USERFLOW.CARTOONS.URL}/${url}`
                  }
                })
              }}
              {...logbookAsset && {
                secondaryButton: {
                  additionalClassNames: 'ml-auto w-full md:w-52 md:ml-auto c-button--dark',
                  text: 'Logbook',
                  variant: 'primary',
                  linkButton: { id: `logbook-${contentGroup.id}`, url: logbookAsset, target: '_blank' }
                }
              }}
              footerContent={<LessonAssets linkedAssets={contentGroup.linkedAssets ?? []} roleTag={roleTag} />}
            />

          </li>
        )
      })}
    </ol>
  ) : (
    <p>No lessons available</p>
  )
};